import "./RateAgreementInfoPanel.scss";
import "../../i18n";
import { useTranslation } from "react-i18next";

import "react-datepicker/dist/react-datepicker-min.module.css";

import { SPOTButton } from "spot-component-library/lib/components/SPOTButton";
import { Panel } from "spot-component-library/lib/components/basic/panel/Panel";
import React from "react";

type RateAgreementInfoPanelProps = {
    isRateAgreementPossible: boolean;
    debtId?: string;
};

export const RateAgreementInfoPanel = (props: RateAgreementInfoPanelProps) => {
    const { t } = useTranslation();

    const goToRateCalculation = () => {
        window.location.pathname = "/services/rateagreement";
    };
    const goToSinglePayment = () => {
        const parameters = props.debtId ? "?debtno=" + props.debtId : "";
        window.location.href = `${window.location.origin}/index.xhtml${parameters}`;
    };

    return (
        <div className="rate-agreement-info-panel">
            <Panel>
                <div className="rate-agreement-info-panel-content">
                    {props.isRateAgreementPossible ? (
                        <>
                            <h3>{t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_AVAILABLE.HEADER")}</h3>
                            <div className="rate-agreement-info-text">
                                <i className="icon-finish"></i>
                                <p>{t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_AVAILABLE.TEXT")}</p>
                            </div>
                            <SPOTButton type="primary" label={t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_AVAILABLE.BUTTON")} onClick={goToRateCalculation}></SPOTButton>
                        </>
                    ) : (
                        <>
                            <h3>{t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_NOT_AVAILABLE.HEADER")}</h3>
                            <div className="rate-agreement-info-text">
                                <i className="icon-fintech-euro"></i>
                                <p>{t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_NOT_AVAILABLE.TEXT")}</p>
                            </div>
                            <a href="/services/rateagreement/ratenzahlung">
                                <i className="icon-arrow-simple-right"></i>
                                {t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_NOT_AVAILABLE.BUTTON_FURTHER_INFO")}
                            </a>
                            <SPOTButton type="primary" label={t("RATE_AGREEMENT_SUB_FORM.RATE_AGREEMENT_NOT_AVAILABLE.BUTTON")} onClick={goToSinglePayment}></SPOTButton>
                        </>
                    )}
                </div>
            </Panel>
        </div>
    );
};
